/**
 * Generates a UUID v4 without dashes, all uppercase
 */
export const generateBloomlifeId = (): string => {
  const uuid = crypto.randomUUID()
  return uuid.replace(/-/g, "").toUpperCase()
}
